import { render, staticRenderFns } from "./BaseTextBillboard.vue?vue&type=template&id=542f186d&scoped=true&"
import script from "./BaseTextBillboard.vue?vue&type=script&lang=js&"
export * from "./BaseTextBillboard.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextBillboard.vue?vue&type=style&index=0&id=542f186d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f186d",
  null
  
)

export default component.exports